<template>
  <!-- 企业管理 -->
  <div class="account_manage">
    <company-search
      ref="searchBox"
      class="search_box"
      @search-change="changeSearch"
      @add-company="add"
    >
    </company-search>
    <company-table
      class="search_table"
      :loading="loading"
      :companyList="companyList"
      :params="tableParams"
      @change-page="changePage"
      @update="getCompanyList"
      @edit-company="editCompany"
      @just-company="justCompany"
    >
    </company-table>
    <company-edit
      :visible="ifEdit"
      :edit="edit"
      :initFormData="currentData"
      @close-modal="ifEdit = false"
      @update="getCompanyList"
    >
    </company-edit>

    <company-just
      :visible="ifJust"
      :initFormData="currentData"
      @close-modal="ifJust = false"
      @update="getCompanyList"
    ></company-just>
  </div>
</template>

<script>
import companySearch from "./companySearch.vue";
import companyTable from "./companyTable.vue";
import companyEdit from "./companyEdit.vue";
import companyJust from "./companyJust.vue";
export default {
  name: "AccountManage",
  components: {
    companySearch,
    companyTable,
    companyEdit,
    companyJust,
  },
  data() {
    return {
      companyList: [], //账号列表
      tableParams: {
        // 分页器的参数
        total: 0,
        page: 1,
        size: 10,
      },
      loading: false,
      ifEdit: false, // 是否展示modal
      ifJust: false, // 是否展示权限分配
      edit: false, // 当前弹窗状态是编辑还是添加
      currentData: {}, // 当前编辑所选的数据
    };
  },
  computed: {},
  mounted() {
    this.getCompanyList();
  },
  methods: {
    // 获取账号列表
    getCompanyList(val) {
      this.loading = true;
      const data = {
        page: this.tableParams.page,
        size: this.tableParams.size,
        body: val || this.$refs.searchBox.searchForm,
      };
      this.$http({
        url: "/enterprise/listPage",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.code === 200) {
            this.companyList = res.data.list || [];
            this.tableParams.total = res.data.total;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "获取企业列表接口请求失败",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 搜索更新
    changeSearch(val) {
      this.tableParams.page = 1;
      this.getCompanyList(val);
    },
    changePage(page) {
      this.tableParams.page = page;
      this.getCompanyList();
    },
    // 点击弹窗弹出添加
    add() {
      this.edit = false;
      this.ifEdit = true;
      this.ifJust = false;
    },
    // 点击弹窗弹出编辑
    editCompany(row) {
      this.currentData = row;
      this.edit = true;
      this.ifJust = false;
      this.ifEdit = true;
    },
    // 点击弹窗弹出权限分配
    justCompany(row) {
      this.currentData = row;
      this.edit = false;
      this.ifJust = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.account_manage {
  height: 100%;
  display: flex;
  flex-direction: column;
  .search_table {
    flex: 1;
    height: 0;
  }
}

// .form {
//   width: 668px;
//   flex-shrink: 0;
// }
// $logo-size: 32px;
// .logo {
//   width: $logo-size;
//   height: $logo-size;
// }
</style>




// WEBPACK FOOTER //
// src/pages/index/views/companyManage/index.vue